import * as Rx from "rxjs"
import { retry, switchMap } from "rxjs/operators"
import { request } from "../utils/http"

export type LoginResponsePayload = {
    session: string
    role: string
    user_id: string
}

export const login = (
    headers: Record<string, any>,
    email: string,
    password: string
): Rx.Observable<LoginResponsePayload> =>
    Rx.from(
        request({
            method: "POST",
            path: "/auth/login",
            headers: headers,
            body: {
                email: email,
                password: password,
            },
        })
    ).pipe(
        retry(3),
        switchMap(result =>
            result && result.session ? Rx.of(result) : Rx.throwError(() => new Error("no session in response"))
        )
    )
